export default __webpack_public_path__ + "static/media/CalendarOutlineIcon.556f82d5.svg";